import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

export const fetchAllGeneSets = async () => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/genesets/get_all_genesets/`)

    return data.results.map(({ id, name, organisation, genes = [], notes = '', created, modified, predefined }) => {
      const label = predefined ? name : `${name} - ${organisation}`

      return {
        id,
        value: name,
        label,
        custom: true,
        genes,
        notes,
        created,
        modified,
        organisation,
      }
    })
  } catch (error) {
    console.error('Error fetching all gene sets:', error)
    return []
  }
}

export const fetchGeneSet = async () => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/genesets/`)

    if (!data?.results || !Array.isArray(data.results)) {
      console.error('API did not return expected data structure:', data)
      return []
    }

    return data.results.map(({ id, name, organisation, genes = [], notes = '', created, modified }) => ({
      id,
      value: name,
      label: `${name}${organisation ? ` - ${organisation}` : ''}`,
      custom: true,
      genes,
      notes,
      created,
      modified,
      organisation,
    }))
  } catch (error) {
    console.error('Error fetching gene sets:', error)
    return []
  }
}

export const createGeneSet = async (name, content, notes) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/genesets/`, {
      name,
      genes: content,
      notes,
    })
    return data
  } catch (error) {
    if (error.response && error.response.status === 409) {
      throw new Error('A gene panel with this name already exists.')
    } else {
      throw new Error('Failed to create gene panel. Please try again.')
    }
  }
}

export const removeGeneSet = async (id) => {
  try {
    const { data } = await axios.delete(`${API_BASE_URL}/genesets/${id}/`)
    return data
  } catch (error) {
    console.error('Error removing gene set:', error)
    throw error
  }
}
